import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import { toast } from 'react-toastify';

const EyeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);
const EyeOffIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-6.5 0-10-7-10-7a18.5 18.5 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A10.9 10.9 0 0 1 12 5c6.5 0 10 7 10 7a18.5 18.5 0 0 1-2.16 3.19" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
);

function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`${API_URL}/auth/login`, {
                email,
                password
            });

            const token = response.data.token;
            const role = response.data.role;

            if (role !== 'ADMIN') {
                toast.error('Access denied. Admin only.');
                setLoading(false);
                return;
            }

            localStorage.setItem('token', token);
            localStorage.setItem('role', role);
            localStorage.setItem('email', email);
            toast.success('Admin login successful!');
            navigate('/admin-dashboard');

        } catch (err) {
            toast.error('Invalid credentials');
        }
        setLoading(false);
    };

    return (
        <div className="auth-page">
            <div className="auth-card" style={{ border: '1px solid var(--error)' }}>
                <div className="auth-brand fade-up delay-1">
                    <h1 className="auth-logo">infloir</h1>
                    <p className="auth-tagline" style={{ color: 'var(--error)' }}>Admin Portal</p>
                </div>

                <div className="fade-up delay-2" style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h2 className="auth-title">Authorized Access Only</h2>
                    <p className="auth-subtitle">Please verify your credentials</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-field fade-up delay-3">
                        <label className="form-label" htmlFor="email">Admin Email</label>
                        <input
                            id="email"
                            type="email"
                            placeholder="admin@infloir.online"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-field fade-up delay-4">
                        <label className="form-label" htmlFor="password">Password</label>
                        <div className="input-wrap">
                            <input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Enter admin password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="icon-btn"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                            </button>
                        </div>
                    </div>

                    <div className="fade-up delay-5">
                        <button type="submit" className="btn-primary auth-submit" style={{ background: 'var(--error)', color: 'white' }} disabled={loading}>
                            {loading && <span className="spinner" style={{ borderTopColor: 'white' }} />}
                            {loading ? 'Verifying...' : 'Authenticate'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AdminLogin;